// @flow

export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_TYPE = 'password'
export const TEXT_TYPE = 'text'
